import React from 'react';
import brandLogo from '../assets/brand-logo.png';

// The website logo for pages that are not themselves navy - the two sign-in
// screens. Its wordmark is white on a transparent background, so it sits on a
// navy tile to stay readable on the light cards those pages use.
const BrandBadge = () => (
  <div className="inline-flex items-center rounded-2xl bg-primary-900 px-4 py-3 shadow-[0_8px_24px_rgba(33,57,102,0.28)] min-[600px]:px-5 min-[600px]:py-3.5">
    <img
      src={brandLogo}
      alt="Dryer Master"
      className="block h-[34px] w-auto min-[600px]:h-10"
    />
  </div>
);

export default BrandBadge;
